module.exports = __webpack_public_path__ + "static/media/468x60_0045_ru.3c9cc26e.jpg";